<template lang="pug">
  //- **
  //- * ローディングアニメーション, `./fade.vue` コンポーネント内のみで使う
  //- * @components
  //- **
  div.p_progress(v-if="loading && $store.state.useLoadingWindow && $route.name === 'index'")
    div.p_progress-door.p_progress-door-top(ref="top")
    div.p_progress-door.p_progress-door-bottom(ref="bottom")
    div.p_progress-inner(ref="logo")
      div.p_progress-bar
        div.-bar(v-bind:style="{width: progressNowPosition + '%'}")
</template>

<script>
import imagesLoaded from 'imagesloaded'

export default {
  data: () => ({
    loading: true,
    width: 0,
    loadedImg: 0,
    progressNowPosition: 0,
    progressNowCount: 0,
    imgNum: null,
    container: null,
    imgLoaded: null,
    timer: null,
    content: null,
    html: null,
  }),
  mounted: function () {
    this.container = document.querySelector('#container')
    this.html = document.querySelector('html')

    let imgLoaded = imagesLoaded(this.container)
    let _self = this

    if (_self.$route.name === 'index' && _self.$store.state.useLoadingWindow) {
      // _self.setContainerPosition()
      _self.html.classList.add('overflow')
    }

    _self.imgNum = imgLoaded.images.length

    if (_self.imgNum <= 0) {
      _self.finish()
      return false
    }
    _self.timer = setInterval(_self.progressMonitor, 1000/50)
    imgLoaded.on('progress', function(instance, image) {
      _self.loadedImg++
    })
  },
  methods: {
    start() {
      this.loading = true
      this.$store.commit('IS_LOADING', true)
    },
    finish() {
      let useLoading = this.$store.state.useLoadingWindow
      let route = this.$route.name

      if (useLoading && route === 'index') {
        this.hideLogo()
      } else {
        // ~/components/TheEyecatch.vue でアニメーションを発火させる
        this.$store.commit('SHOW_EYECATCH', true)
      }

      this.fadeContainer()
    },
    setContainerPosition: function () {
      TweenMax.set(this.container, {
        // y: -400,
        // autoAlpha: 0,
      });
    },
    fadeContainer: function () {
      let _self = this;
      TweenMax.to(this.container, .8, {
        delay: .5,
        // y: 0,
        autoAlpha: 1,
        ease: Power2.easeOut,
        clearProps: 'y',
      });
    },
    hideLogo: function () {
      let _self = this
      let logo = this.$refs.logo
      TweenMax.to(logo, .8, {
        autoAlpha: 0,
        ease: Power2.easeOut,
        onComplete: _self.fadeDoor(),
      })
    },

    fadeDoor: function () {
      let _self = this
      let el = [
        this.$refs.top,
        this.$refs.bottom
      ]

      TweenMax.to(el, .4, {
        delay: .3,
        autoAlpha: 0,
        ease: Power2.easeOut,
        onComplete () {
          _self.html.classList.remove('overflow')
          _self.loading = false
          _self.$store.commit('IS_LOADING', false)
        }
      })
      // ~/components/TheEyecatch.vue でアニメーションを発火させる
      // _self.$store.commit('SHOW_EYECATCH', true)
      // _self.fadeContainer()
    },
    progressMonitor: function () {
      let progressPosition = (this.loadedImg/this.imgNum) * 100
      this.progressNowPosition += (progressPosition-this.progressNowPosition) * 0.1
      this.progressNowCount = this.progressNowPosition.toFixed(0)

      if (this.progressNowPosition >= 100) {
        clearInterval(this.timer)
        this.finish()
      }

      if (this.progressNowPosition > 99.9) {
        this.progressNowPosition = 100
      }

    },
  },
}
</script>

<style scoped lang="scss">
.p_progress {
  @include pc {
    min-width: $min_l#{px};
  }
  width: 100%;
  height: 100%;
  min-width: $min_s#{px};
  position: fixed;
  z-index: 1000;
  left: 0;
  // top: 400px;
  top: 0;

  &-door {
    width: 100%;
    height: 50%;
    display: block;
    position: absolute;
    left: 0;

    &-top {
      @include pc {
        background-size: cover;
        background-color: $palet1;
      }
      top: 0;
      background-size: cover;
      background-color: $palet1;
    }

    &-bottom {
      @include pc {
        background-size: cover;
        background-color: $palet1;
      }
      bottom: 0;
      background-size: cover;
      background-color: $palet1;
    }
  }

  &-inner {
    @include pc {
      min-width: rem(1050,2);
      min-height: rem(2);
    }
    @include sp {
      min-width: rem(300);
      min-height: rem(2);
    }
    width: vw(1049,2800);
    height: rem(2);
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    margin: auto;
  }

  &-bar {
    width: rem(122,2);
    height: 3px;
    background: rgba(#fff,.2);
    position: relative;
    margin: 0 auto;

    .-bar {
      background: #fff;
      width: 0;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheLoading.vue